module.exports = __webpack_public_path__ + "static/img/w3-4.d543264.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pagess/gdd102/w3-4.png
// module id = gt3f
// module chunks = 1